<div class="detail-page">
  <app-asiakas-otsikko otsikko="Sisäinen arkisto" paluuUrl="/asiakkaat" [asiakas]="asiakasObservable | async"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Metadata (Lemonator): <a [href]="(urit | async).uri" target="_BLANK">{{ (urit | async).display }}</a>
      </div>
    </div>
  }

  <div class="kuvaus">Sisäiseen arkistoon voidaan tallentaa asiakkaaseen liittyviä dokumentteja, jotka eivät saa näkyä asiakkaalle.</div>

  <app-primary-button (click)="openDialog()" actionId="Avasi dialogin: Lisää tiedosto sisäiseen arkistoon" styles="margin: 50px 0 30px 0"> Lisää tiedosto </app-primary-button>

  <table>
    <i class="fa fa-lock" style="position: absolute; left: 35%; font-size: 550px; color: grey; z-index: 0; opacity: 0.08; pointer-events: none"></i>

    <tr>
      <th>Tallenna</th>
      <th>Esikatsele</th>
      <th class="wide">Tiedoston nimi</th>
      <th class="wide">Lataaja</th>
      <th class="wide">Ladattu</th>
      <th class="extra-wide">Lisätiedot</th>
      <!-- <th class="wide">Tyyppi</th> -->
      <td>&nbsp;</td>
    </tr>

    @for (file of arkistoFilesObservable | async; track file) {
      <tr>
        <td>
          <app-icon-button matTooltip="Lataa tiedosto koneelle" actionId="Lataa tiedosto koneelle" (click)="downloadFile(file)">
            <i class="fa fa-arrow-circle-o-down" style="font-size: 20px"></i>
          </app-icon-button>
        </td>
        <td style="text-align: center">
          @if (file.canPreview && !file.previewOpen) {
            <app-icon-button matTooltip="Avaa esikatseluun" actionId="Avaa tiedosto esikatseluun" (click)="previewFile(file)">
              <i class="fa fa-eye" style="font-size: 20px"></i>
            </app-icon-button>
          }
          @if (file.previewOpen) {
            <app-icon-button matTooltip="Lopeta esikatselu" actionId="Lopeta tiedoston esikatselu" (click)="stopFilePreview(file)">
              <i class="fa fa-eye-slash" style="font-size: 20px"></i>
            </app-icon-button>
          }
        </td>
        <td class="wide">{{ file.fileName }}</td>
        <td class="wide">{{ file.lataajaName }}</td>
        <td class="wide">{{ file.ladattuDateString }}</td>
        <td class="extra-wide">{{ file.lisatiedot }}</td>
        <!-- <td class="wide">{{file.typeName}}</td> -->
        <td>
          <app-icon-button (click)="markAsDeleted(file)" actionId="Avasi dialogin: Poista tiedosto sisäisestä arkistosta" matIcon="delete"> </app-icon-button>
        </td>
      </tr>
      @if (file.previewOpen) {
        <tr>
          <td colspan="7">
            @if (file.previewLoading) {
              <div style="margin: 20px; text-align: center">
                Esikatselua ladataan...
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            } @else {
              @if (file.previewType === 'pdf') {
                <div app-pdf-viewer [url]="file.previewFileDataUrl | async"></div>
              }
              @if (file.previewType === 'jpg' || file.previewType === 'png') {
                <div app-image-zoom [thumbImage]="file.previewFileDataUrl | async"></div>
              }
            }
          </td>
        </tr>
      }
    }
  </table>
</div>
